import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { IMGIX_URL } from '@src/env';

const Companies = () => {
  const companies = [
    {
      name: 'Sequoia',
      className: 'h-[16px] w-[117px] sm:h-[18px] sm:w-[132px]',
      sizes: '100px',
    },
    {
      name: 'Apple',
      className: 'h-[43px] w-[45px] sm:h-[50px] sm:w-[52px]',
      sizes: '50px',
    },
    {
      name: 'Goldman',
      className: 'h-[43px] w-[43px] sm:h-[50px] sm:w-[50px]',
      sizes: '50px',
    },
    {
      name: 'Google',
      className: 'h-[43px] w-[43px] sm:h-[50px] sm:w-[50px]',
      sizes: '50px',
    },
    {
      name: 'Meta',
      className: 'h-[54px] w-[68px] sm:h-[61px] sm:w-[76px]',
      sizes: '100px',
    },
  ];

  return (
    <div className="mt-24 flex flex-wrap items-center justify-center gap-x-64 gap-y-16 sm:gap-48 md:mt-48 md:gap-[92px]">
      {companies.map(({ className, name, sizes }) => (
        <LazyImgixImage
          key={name}
          alt={`${name} logo`}
          className="h-full w-full"
          src={`${IMGIX_URL}/global/subscribe/${name}_Logo.png`}
          sizes={sizes}
          wrapperClassName={className}
        />
      ))}
    </div>
  );
};

export default Companies;
